export default class BatchDetail {
  /**
   * Create new batch detail and set properties based on the given object.
   *
   * @param {Object} obj
   */
  constructor (obj) {
    Object.assign(this, obj)
  }

  /**
   * @return {Date}
   */
  get transferDate () {
    return this._transferDate
  }

  /**
   * @param {string} value
   */
  set transferDate (value) {
    this._transferDate = new Date(value)
  }

  /**
   * @param {string} value
   */
  set amount (value) {
    this._amount = parseFloat(value)
  }

  /**
   * @return {Int}
   */
  get amount () {
    return this._amount
  }
}
